import { css, cx } from '@emotion/css'

import { FormattedMessage, useIntl } from 'react-intl'
import React from 'react'
import { WithTooltip } from '../../design-system'
import { metadataCss } from '../text'
import { theme as deprecatedTheme } from '../../styled'
import { theme } from '@contrast-security-inc/design-system-foundations'

export const metadataListItemCss = css`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 5px;

  @media (min-width: 768px) {
    &:not(:last-child)::after {
      margin-left: 10px;
      margin-right: 10px;
      content: '|';
      color: ${theme.color.neutral40};
    }
  }
`

export const metadataLabelCss = cx(
  metadataCss,
  css`
    font-weight: ${deprecatedTheme.fontWeights.primary.bold};
    margin: 0 6px 0 0;
  `
)

interface MetadataListProps {
  readonly children: React.ReactNode | React.ReactNode[]
  readonly className?: string
}

export function MetadataList(props: MetadataListProps) {
  const metadataListCss = css`
    padding: 0;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;

    @media (min-width: 768px) {
      flex-direction: row;
    }

    list-style: none;
    line-height: normal;

    margin-bottom: 0px;
  `

  const { children, className } = props
  return <ul className={cx(metadataListCss, className)}>{children}</ul>
}

interface MetadataListItemProps {
  readonly label?: any
  readonly value: React.ReactNode
  readonly className?: string
  readonly isOverriddenByUser?: boolean
  readonly dataTestid?: string
  readonly e2eTestid?: string
}

export function MetadataListItem(props: MetadataListItemProps) {
  const {
    label,
    value,
    className,
    isOverriddenByUser = false,
    dataTestid,
    e2eTestid
  } = props

  const { formatMessage } = useIntl()

  return (
    <li className={cx(metadataListItemCss, className)} data-testid={dataTestid}>
      {!!label && <span className={metadataLabelCss}>{label}:</span>}
      <span className={metadataCss} data-e2e={e2eTestid}>
        {!!value ? value : formatMessage({ id: 'title_unknown' })}
      </span>
      {isOverriddenByUser && (
        <WithTooltip
          renderTooltipContent={() => {
            return (
              <FormattedMessage id="detail_applicationDashboard_metadataValueOverridden">
                {(msg) => <div>{msg}</div>}
              </FormattedMessage>
            )
          }}
        >
          {() => (
            <span
              className={cx(
                metadataCss,
                css`
                  margin-left: 2px;
                `
              )}
            >
              *
            </span>
          )}
        </WithTooltip>
      )}
    </li>
  )
}
